import type theme from '#build/ui/command-palette'
import type { DeepPartial } from '@nuxt/ui'

const commandPalette: DeepPartial<typeof theme> = {
  slots: {
    root: 'divide-(--ui-border-muted)',
    viewport: 'divide-(--ui-border-muted)',
    empty: 'text-cvt-text-grey',
    label: 'py-1.5 px-2 text-cvt-text-black',
    item: 'data-highlighted:text-cvt-text-black data-highlighted:before:bg-cvt-purple-800/50 text-cvt-text-black outline-hidden gap-2 px-2 py-1.5 before:rounded-lg',
    itemLeadingIcon: 'group-data-highlighted:text-cvt-text-black text-cvt-cloud-700 transition-colors',
    itemTrailingHighlightedIcon: 'text-cvt-cloud-700',
    itemLabel: 'text-cvt-text-black',
    itemLabelBase: 'text-(--ui-text-highlighted) [&>mark]:text-(--ui-bg) [&>mark]:bg-(--ui-primary)',
    itemLabelPrefix: 'text-(--ui-text)',
    itemLabelSuffix: 'text-cvt-cloud-700 [&>mark]:bg-cvt-burgundy-500 [&>mark]:text-old-neutral-50',
  },
  variants: {
    active: {
      true: {
        item: 'text-cvt-text-black before:bg-cvt-cloud-500',
        itemLeadingIcon: 'text-cvt-text-black',
      },
      false: {
        item: 'data-highlighted:text-cvt-text-black data-highlighted:before:bg-cvt-cloud-500/50 text-cvt-text-black transition-colors before:transition-colors',
        itemLeadingIcon: 'group-data-highlighted:text-cvt-text-black text-cvt-cloud-700 transition-colors',
      },
    },
  },
}

export default commandPalette
